import { KYMW6001Component } from './kymw6001.component';
import { ImageListInfo } from './vo/image_list_info.model';

/**
 * 商品画像情報画面の値を管理するクラス
 *
 * @export KYMW6001Model
 * @class KYMW6001Model
 */
export class KYMW6001Model {

  KYMW6001Component: KYMW6001Component;

  /** 受注コード */
  public orderCode: string = <string>'';
  /** 配達企画回（翌週 */
  public catalogId: string = <string>'';
  /** 媒体 */
  public mediumType: string = <string>'';
  /** 媒体名 */
  public mediumName: string = <string>'';
  /** 特集コード */
  public featureCode: string = <string>'';
  /** 特集名 */
  public featureName: string = <string>'';  
  /** 部門 */
  public classCode: string = <string>'';
  /** 部門名 */
  public className: string = <string>'';  
  /** Ｐコード */
  public pCode: string = <string>'';
  /** マルチクロス */
  public multiOrCrossFlg: string = <string>'';
  /** 画像未指定 */
  public imageNoUseFlag: string = <string>'';
  /** 未確認 */
  public imageCheckFlag: string = <string>'';
  /** 画像一覧 */
  public imageListInfo: ImageListInfo[] = [];
  /** 総件数 */
  public totalNum: number = <number>0;
  /** 開始件数 */
  public startDispNum: number = <number>1;
  /** 終了件数 */
  public endDispNum: number = <number>0;
  /** ページ番号 */
  public pageNum: number = <number>1;
  /** 商品ごとの取扱生協と注文コード */
  public pcodeInfoList: PCodeInfo[] = [];
}

type PCodeInfo = {
  pCode: string,
  coopInfoList: [{
    coopCode: string,
    orderNum: string,
  }]
}
